<template>
  <!-- bg_white bg_gray  -->
  <div v-show="showTit === '分红融资'">
    <p class="nothing-tips" v-if="!shareBonusData && !rzfxData && affairQuery">暂无数据</p>
    <section class="main">
      <!-- 分红转送 -->
      <hgroup class="mainPage" v-if="shareBonusData">
        <header>分红转送<a :href="shareBonusData.moreUrl">更多</a></header>
        <div class="m-block">
          <table
            class="m-table-two m-table-hk m-table-col3"
            border="0"
            width="100%"
          >
            <tr>
              <th>除权除息日</th>
              <th>派息日</th>
              <th>分配方案</th>
            </tr>
            <tr v-for="(item, index) in shareBonusData.fhpxList.slice(0,3)" :key="index">
              <td>{{ item.EXDATE_S }}</td>
              <td>{{ item.ISSUEDATE_S }}</td>
              <td>
                <strong>{{ item.FASM }}</strong>
              </td>
            </tr>
          </table>
        </div>
      </hgroup>
      <!-- 融资发行 -->
      <hgroup class="mainPage xxtx" v-if="rzfxData">
        <header>融资发行</header>
        <ul class="xxtx-timeLine">
          <li v-for="(item,index) in rzfxData" :key="index">
            <span class="time">{{item.fbrq.substr(4,2) + "-" + item.fbrq.substr(6,2)}}<small>{{item.fbrq.substr(0,4)}}</small></span>
            <p>
              <strong>
                {{ item.fxdx ? "对" + item.fxdx + "，" : "" }}
                {{ "计划发行"+ item.fxgs + "股，" }}
                {{ item.fxjg ? "每股价格"+ item.fxjg + "" + item.psbz + "，":""}}
                {{ item.rzze ? "融资总额预计为" + item.rzze + "" + item.psbz + "，" : "" }}
                {{ item.fxrq && item.fxrq !== "19000101" ? "计划" + checkTime(item.fxrq) + "开始执行" : "" }}
              </strong>
            </p>
          </li>
        </ul>
      </hgroup>
    </section>
    <Loading v-if="!affairQuery"></Loading>
    <Declare v-if="affairQuery && (shareBonusData || rzfxData)"></Declare>
  </div>
</template>

<script>
import { getEventData } from "../api/index";
import mixins from '../mixins/index';
import Loading from "../components/loading"
  import Declare from "../components/declare"
export default {
  name: "Didend",
  props: ["showTit", "token"],
  data() {
    return {
      affairQuery: false,
      shareBonusData: null,
      rzfxData: null
    };
  },
  components:{Loading,Declare},
  mixins: [mixins],
  filters: {},
  watch: {
    showTit: {
      handler(newval, old) {
        if (newval === "分红融资" && !this.affairQuery) {
          this.code = this.getUrlQuery("code");
          this.$nextTick(() => {
            this.getAffairData();
          });
        }
      },
      immediate: true,
    },
  },
  created() {},
  mounted() {},
  methods: {
    getAffairData: function () {
      let that = this;
      let shareBonus = that.code + "-B5-1"; // 分红转送
      let rzfxKey = "mapdata/fhrz/rzfx/" + that.code; // 融资发行
      let busiTypeArr = [shareBonus,rzfxKey];
      let objs = {
        busiCode: window.config.busiCode,
        merId: window.config.merId,
        reqData: {
          busiType: busiTypeArr.join(),
          category: "hkf10",
        },
      };
      getEventData(JSON.stringify(objs), that.token)
        .then((res) => {
          that.affairQuery = true;
          if (res.resCode === "000000") {
            that.shareBonusData = res.resData.hasOwnProperty(shareBonus)
              ? res.resData[shareBonus]
              : null;
            that.rzfxData = res.resData.hasOwnProperty(rzfxKey)
              ? res.resData[rzfxKey].data
              : null;
          }
        })
        .catch(() => {
          that.affairQuery = true;
        });
    },
    checkTime:function(time){
      if(time){
        return time.substr(0,4) + "-" + time.substr(4,2) + "-" + time.substr(6,2)
      }
    }
  },
};
</script>
<style lang="less" scoped></style>
